{{if $data.type == 'review' }}
{{set detaiData = $data.data}}
<!--审核不通过弹窗-->
<div class="modal-box modal-review">
    <div class="modal-head">
        资源审核状态
        <a href="javascript:void (0);" class="close-modal _closeModal"></a>
    </div>
    <div class="modal-content">
        <div class="form-review">
            <div class="m-form-group row1">
                <p class="bold-label">审核未通过原因</p>
                <div class="form-content">
                    <p class="value-text red-text">{{ detaiData.audit_reason }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">资源类型</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.source_type == 1 ?'视频':'挂图' }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">标题</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.source_name }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">封面</p>
                <div class="form-content">
                    <img src="{{ detaiData.logo }}" class="imgs" alt="">
                </div>
            </div>
            {{if detaiData.source_type == 1}}
            <div class="m-form-group">
                <p class="bold-label fl">上传视频</p>
                <div class="form-content">
                    <div class="video" style="width:160px;height:90px" id="video" data-url="{{ detaiData.video_url }}">
                    </div>
                </div>
            </div>
            {{else}}
            <div class="m-form-group">
                <p class="bold-label fl">上传图片</p>
                <div class="form-content">
                    {{each detaiData.pictures}}
                    <img src="{{$value.logo}}" class="imgs" alt="">
                    {{/each}}
                </div>
            </div>
            {{/if}}
            <div class="m-form-group">
                <p class="bold-label fl">{{ detaiData.source_type == 1 ?'视频':'图片' }}尺寸</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.ratio }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">文件大小</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.res_size }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">文件格式</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.res_format }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">年份</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.particular_year }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">类别</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.classification }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">语言</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.res_language }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">标签</p>
                <div class="form-content">
                    {{each detaiData.tag_name}}
                    <p class="value-text label">{{$value}}</p>
                    {{/each}}
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">{{ detaiData.source_type == 1 ?'视频':'挂图' }}简介</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.abstract }}</p>
                </div>
            </div>
            <div class="m-form-group">
                <p class="bold-label fl">发表身份</p>
                <div class="form-content">
                    <p class="value-text">{{ detaiData.audit_type == '2'?'组织':'个人' }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-foot">
        <button class="btn btn-sm _replayBtn" data-id="{{ detaiData.id }}">重新申请</button>
        <button class="btn btn-sm ml btn-red _deleteBtn" data-id="{{ detaiData.id }}" data-type="resource">删除资源</button>
    </div>
</div>
{{/if}}

{{if $data.type == 'share' }}
<div class="modal-box share-modal">
    <div class="modal-head">
        分享
        <a href="javascript:void (0);" class="close-modal _closeModal"></a>
    </div>
    <div class="modal-content">
        <div class="common-share-box _common-share"></div>
    </div>
</div>
{{/if}}
{{if $data.type == 'download' }}
<div class="modal-box">
    <div class="modal-head">
        科普新疆云资源下载版权声明
        <a href="javascript:void (0);" class="close-modal _closeModal"></a>
    </div>
    <div class="modal-content">
        <p>科普新疆云根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。</p>
        <p>科普新疆云作为网络服务提供者，对非法转载，盗版行为的发生不具备充分的监控能力，如果您认为科普新疆云用户通过科普新疆云提供的信息存储空间所上载、传播的内容侵犯了您的相关权益的，
            请您向科普新疆云发出权利通知，科普新疆云将根据相关法律规定采取措施删除相关内容，您可以向科普新疆云所设立的专门接受版权投诉和侵权通知的邮箱发送通知书。
            本网站所有作品均由本公司或版权所有人授权发布，如果您侵犯了该作品的知识产权，新疆维吾尔自治区科学技术协会有权依据著作权侵权惩罚性赔偿标准或最高达50万元人民币的法定标准要求赔偿，且有权不以本网站发布的作品授权价格作为参考标准。</p>
        <p>申诉需知</p>
        <p> 投诉方应当提供包含下列文件：</p>
        <p style="text-indent: 2em">1.权利人的姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）。</p>
        <p style="text-indent: 2em">2.要求删除或者断开链接的侵权作品的准确名称和网络地址，以便科普新疆云能够发现并初步审核涉嫌侵权作品。</p>
        <p style="text-indent: 2em">3.认为构成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明，以及对涉嫌侵权作品侵权事实的举证。</p>
        <p style="text-indent: 2em">4.通知书需由权利人或其合法授权人亲笔签名，若为单位则需加盖单位公章。</p>
        <p style="text-indent: 2em">5.权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。</p>
        <p>一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。</p>
        <p>
            在科普新疆云上传作品的用户视为同意科普新疆云就上述情况所采用的相应措施，科普新疆云不因此而承担任何违约责任或其他任何法律责任。科普新疆云在收到上述通知后会发送电子邮件通知上传该作品的用户，对于多次上传涉嫌侵权作品的用户，科普新疆云将有权删除下架；若发现盗图3张以上的用户，则取消其上传资格；若发现盗图5张以上的用户，将永久封禁账号等惩罚措施。</p>
        <p>在您发送邮件后，工作人员会尽快处理，由于涉及内容不同，所需周期也不同，请您耐心等待。</p>
        <p>版权举报通道</p>
        <p>电话：400-998-7011（周一到周五，9:30-18:00）</p>
        <p>邮箱：copyright@58pic.com</p>
        <p>温馨提示：</p>
        <p>网站作品模板内出现的任何摄影图、商品图、字体、人物肖像仅供作参考展示，未经权利人许可不得用于商用，若擅自使用，后果将由使用者自行承担。</p>
    </div>
    <div class="modal-foot">
        <button class="btn btn-blue _showDownloadSelectModal">知道了</button>
    </div>
</div>
{{/if}}
{{if $data.type == 'downloadForm' }}
<div class="modal-box">
    <div class="modal-head">
        请选择您的下载用途（可多选）
        <a href="javascript:void (0);" class="close-modal _closeModal"></a>
    </div>
    <div class="modal-content">
        <div class="form-group _downLoadType">
            <label for="download1" class="checkbox-item">
                <input type="checkbox" id="download1" name="type" value="电视台">电视台
            </label>
            <label for="download2" class="checkbox-item">
                <input type="checkbox" id="download2" name="type" value="广播">广播
            </label>
            <label for="download3" class="checkbox-item">
                <input type="checkbox" id="download3" name="type" value="新媒体">新媒体
            </label>
            <label for="download4" class="checkbox-item">
                <input type="checkbox" id="download4" name="type" value="新媒体">教学课件
            </label>
            <label for="download5" class="checkbox-item">
                <input type="checkbox" id="download5" name="type" value="宣传册">宣传册
            </label>
            <label for="download6" class="checkbox-item">
                <input type="checkbox" id="download6" name="type" value="公共大屏">公共大屏
            </label>
            <label for="download7" class="checkbox-item">
                <input type="checkbox" id="download7" name="type" value="宣传栏">宣传栏
            </label>
            <label for="download8" class="checkbox-item row">
                <input type="checkbox" id="download8" name="type" value="其他">其他
                <input type="text" placeholder="可自行填写，不可超过20个字" class="form-control _elseText" maxlength="20">
            </label>
        </div>
    </div>
    <div class="modal-foot">
        <button class="btn btn-sm btn-blue _saveDownloadBtn">提交</button>
        <button class="btn btn-sm ml _closeModal">取消</button>
    </div>
</div>
{{/if}}
<!-- 未认证下载弹窗 -->
{{if $data.type == 'authentication' }}
<div class="modal-box">
    <div class="modal-head">
        <a href="javascript:void (0);" class="close-modal _closeModal"></a>
    </div>
    <div class="modal-content">
        <p class="tc" style="margin: 50px 0;">科普新疆云资源仅限认证用户下载使用</p>
    </div>
    <div class="modal-foot">
        <a class="btn btn-blue" href="/ucenter/authdetail">去认证</a>
    </div>
</div>
{{/if}}

{{if $data.type == 'addtitle' }}
<tr>
    <td>
        <input type="hidden" name="title_id" class="_titleId">
        <input type="text" data-id="" name="title_name" class="form-control _titleInput" readonly autocomplete="off"  maxlength="50" value="" placeholder="请选择">
        <div class="name-list _nameList" style="display: none;"></div>
    </td>
    <td>
        <input type="text" name="grant_unit" class="form-control _giveCompany" maxlength="50" value="">
    </td>
    <td class="year">
        <input type="text" name="grant_year" class="form-control _giveYear" id="giveYear{{data.idx}}" maxlength="4" readonly>
        <a href="javascript:;" class="delete-title _deleteTitlte"></a>
    </td>
</tr>
{{/if}}